export default host => (fileId) => `${host}/contentCreators/${fileId}/download`